import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchInstitutionAggregates = () => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });

		const res = await instance.get("/institution-aggregates");
		return res.data;
	};
	return useQuery(["institution", "aggregates"], () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchInstitutionAggregates;
